import { render, staticRenderFns } from "./ProcedureAndSOP.vue?vue&type=template&id=7bdf1c08&scoped=true&"
import script from "./ProcedureAndSOP.vue?vue&type=script&lang=js&"
export * from "./ProcedureAndSOP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdf1c08",
  null
  
)

export default component.exports